import { render, staticRenderFns } from "./deposit-details.vue?vue&type=template&id=97a3f4fc&scoped=true"
import script from "./deposit-details.vue?vue&type=script&lang=js"
export * from "./deposit-details.vue?vue&type=script&lang=js"
import style0 from "./deposit-details.vue?vue&type=style&index=0&id=97a3f4fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a3f4fc",
  null
  
)

export default component.exports